import {
    FETCH_AGENT_CERTIFICATIONS_REQUEST,
    FETCH_AGENT_CERTIFICATIONS_SUCCESS,
    FETCH_AGENT_CERTIFICATIONS_FAILURE,
} from "../actions/types";

const initialState = {
    certifications: [],
    loading: false,
    error: null,
};

const agentCertificationReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case FETCH_AGENT_CERTIFICATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_AGENT_CERTIFICATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                certifications: Array.isArray(
                    action.payload
                )
                    ? action.payload
                    : [action.payload],
                error: null,
            };

        case FETCH_AGENT_CERTIFICATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default agentCertificationReducer;